module.exports = __webpack_public_path__ + "static/blog-img2-c2a667840b6ba6cd9faf014fa7b9ac2e.jpg";